import {
  BotGraphsData,
  DisplayCurrency,
  RawLineChartDataPoint,
  TimeRange,
} from "@shared/types";
import { DISPLAY_CURRENCIES } from "@shared/common/constants.ts";
import { formatTimeSeriesChartData } from "@shared/utils/charts.ts";
import { changeGraphDataBaseline } from "@shared/features/bots/utils.ts";

export const getFormattedGraphData = (
  data: BotGraphsData | undefined,
  graphType: keyof BotGraphsData,
  timeRange: TimeRange,
  displayCurrency: DisplayCurrency,
  precision?: number,
  totalChange?: number
) => {
  const rawGraphData = data?.[graphType][timeRange] || [];
  let graphData: RawLineChartDataPoint[] = rawGraphData.map((dataPoint) => {
    if (typeof dataPoint[1] === "number")
      return dataPoint as RawLineChartDataPoint;
    return [dataPoint[0], ...dataPoint[1]];
  });
  const yValueIndex = displayCurrency === DISPLAY_CURRENCIES.BTC ? 2 : 1;

  if (graphType === "accumulated_profit") {
    graphData = changeGraphDataBaseline(
      graphData,
      yValueIndex,
      totalChange || 0
    );
  }

  return formatTimeSeriesChartData(
    graphData,
    yValueIndex,
    false,
    undefined,
    precision || 0
  );
};
